


var LOCK_INDEX = [];
function LockCallback(key, action, manual) {
    if (LOCK_INDEX[key])
        return;
    LOCK_INDEX[key] = true;
    var ret = action(function () { delete LOCK_INDEX[key]; });
    if (!manual)
        delete LOCK_INDEX[key];
    return ret;
};


//function Store()
export default function Store() {
    this._handlers = {};
};
//module.exports = Store
//export default Store
window.Store = Store;

// Static
Store._debug = false;
Store.IsPromise = function (value) {
    return (value != undefined && typeof value === 'object' || typeof value === 'Promise' || typeof value === 'promise') && value.then !== undefined && value.then !== null && typeof value.then === 'function';
};
Store.Parse = function (value) {
    return value == undefined || value == null ? '' : value
    //return value;
}
Store.ParseInt = function (value) {
    let valueInt = typeof value === 'number' ? value : parseInt(value, 10);
    if (value === undefined || value === null || isNaN(value) || value === 'NaN')
        return 0;
    else
        return valueInt;
};
Store.ParseBool = function (value) {
    if (Store._debug === true)
        console.log('parse bool ', value, typeof value);
    let valueBool = (typeof value === 'bool' || typeof value === 'boolean') ? value : (value === 'true' || value === 'True' || value === 'TRUE' || value === '1');
    return valueBool;
};
Store.validateName = function (name, event) {
    if (name === undefined || name === null || typeof name !== 'string' || name.length === 0) {
        console.warn('Store: Bad Name!');
        return false;
    }

    name = name.toLowerCase();
    return name;
};

// Instance
/*
'action/type': { value: 'foo', handlers: [ function(newValue, oldValue) { } ] }
Stati:
this._handlers["name"] = undefined => not set / undefined
this._handlers["name"] = [] => initializing..
this._handlers["name"] = [ event ] => initialized / set

this._handlers["name"] = handlerObj
{
    value: 'foo',
    parser: function(value) => value,
    handlers: [
        function(newValue, oldValue) { }
    ]
}
*/
Store.prototype._handlers = {};
Store.prototype.initEx = function (name, value, parser) {
    name = Store.validateName(name);
    if (name === false)
        return false;
    if (value === undefined || value === null) {
        console.warn('Store->init: Bad value (NULL) ', name, value);
        return false;
    }

    if (this.has(name)) {
        if (Store._debug === true)
            console.log('Store->init: bereits initialisiert ', name, value);
        return false;
    }

    // Parser setzen
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        handlerObj = { value: null, handlers: [] };
        this._handlers[name] = handlerObj;
    }

    if (parser != undefined && parser != null && typeof parser === 'function')
        handlerObj.parser = parser;
    else
        handlerObj.parser = Store.Parse;

    return this.set(name, value, true);
};
Store.prototype.init = function (name, event) {
    return this.initEx(name, event, Store.Parse);
};
Store.prototype.initBool = function (name, event) {
    return this.initEx(name, event, Store.ParseBool);
};
Store.prototype.initInt = function (name, event) {
    return this.initEx(name, event, Store.ParseInt);
};

Store.prototype.subscribe = function (name, event, setInitial) {
    name = Store.validateName(name);
    if (name === false)
        return false;
    let toe = typeof event;
    if (event === undefined || event === null || toe !== 'function') {
        console.warn('Store->subscribe: Bad Event!', name, event, toe);
        return false;
    }

    //var hasValue =  this.has(name);
    var oldValue = undefined;
    if (setInitial === true) {
        oldValue = this.get(name);
    }

    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null)
        this._handlers[name] = { value: null, handlers: [event] };
    else
        handlerObj.handlers.push(event);

    if (setInitial === true) // && hasValue === true)
    {
        event(oldValue, oldValue);
    }
};
Store.prototype.unsubscribe = function (name, event) {
    name = Store.validateName(name);
    if (name === false)
        return false;

    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        console.warn('Store->unsubscribe: no Handler found', name);
        return false;
    }

    if (event === undefined || event === null) {
        // alle Handler entfernen
        handlerObj.handlers = [];
        return true;
    }
    else {
        if (typeof event !== 'function') {
            console.warn('Store->unsubscribe: Bad Event! / function');
            return false;
        }

        let handlers = handlerObj.handlers;
        if (handlers === undefined || handlers === null) {
            console.warn('Store->unsubscribe: no Handler found');
            return false;
        }

        let ret = false;

        if (handlers.length > 0) {
            for (let i = handlers.length - 1; i >= 0; i--) {
                if (handlers[i] === event) {
                    handlers.slice(i, 1);
                    ret = true;
                }
            }
        }

        return ret;
    }
};
/*Store.prototype.unsubscribeAll = function(name)
{
    name = Store.validateName(name);
    if (name === false)
        return false;
    
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null)
    {
        console.warn('Store->unsubscribeAll: no Handler found');
        return false;
    }
    handlerObj.handlers = [];
    return true;
};*/
Store.prototype.remove = function (name) {
    name = Store.validateName(name);
    if (name === false)
        return false;

    this._handlers[name] = undefined;
    delete this._handlers[name];
    return true;
};
Store.prototype.clear = function () {
    this._handlers = {};
    return true;
};
Store.prototype.getFnReturnValueInternal = function (value, parser) {
    // Funktion auflösen
    while (value != null && value !== undefined && !Store.IsPromise(value) && typeof value === 'function') {
        value = value();
    }

    // Promise auflösen
    if (Store.IsPromise(value)) {
        let store = this;
        // Falls es ein Promise ist, diesen auflösen
        return value.then(function (ret_value) {
            //value = store.getFnReturnValueInternal(ret_value, parser);
            //return value;
        });
    }

    if (parser !== undefined && parser !== null && typeof parser === 'function') {
        value = parser(value);
    }

    return value;
};
Store.prototype.set = function (name, value, signal) {
    name = Store.validateName(name);
    if (name === false) {
        console.log('Store->set - name not found', name, value, this);
        return false;
    }

    //return LockCallback('someKey',() => {

    var oldValue = this.get(name);

    var isNewValue = false;

    // Falls noch kein Handler existiert, werstmal Wert undefined setzen, damit init nicht öfter aufgerufen wird.
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        if (Store._debug === true)
            console.log('Store->set - initialized', name, this);
        handlerObj = { value: undefined, handlers: [] };
        this._handlers[name] = handlerObj;
        isNewValue = true;
    }

    // --

    // Funktion auflösen
    // so lange auflösen, bis value einen Wert darstellt
    while (value != null && value !== undefined && !Store.IsPromise(value) && typeof value === 'function') {
        value = value();
    }

    // Promise auflösen
    if (value != null && value !== undefined && Store.IsPromise(value)) {
        //console.warn(`Store->set: Promise sind nicht erlaubt! Name: "${name}" `);
        //return;
        let store = this;
        // Falls es ein Promise ist, diesen auflösen
        return value.then(function (ret_value) {
            store.set(name, ret_value, signal);
        });
    }

    // neuen Wert parsen
    if (handlerObj.parser !== undefined && handlerObj.parser !== null && typeof handlerObj.parser === 'function')
        value = handlerObj.parser(value);
    else
        value = Store.Parse(value);

    // --

    let handlers = handlerObj.handlers;
    //var oldValue = handlerObj.value;
    if (oldValue != value || signal === true) {
        handlerObj.value = value;
        //if (Store._debug === true)
        //if (!isNewValue && handlers.length > 0)
        if ((oldValue != value && (signal === undefined || signal === null)) || signal === true) {
            if (Store._debug === true)
                console.warn('Store->set NOTIFY "' + name + '" / Value has Changed  ', oldValue, '  ->  ', value, ' / Signal:' + signal + ' / Listeners: ' + handlers.length);

            let count = handlers.length;
            //for (let i = handlers.length - 1; i >= 0; i--)
            for (let i = 0; i < count; i++) {
                //console.log('set notify', handlers[i]);
                handlers[i](value, oldValue);
            }
        }
        else {
            // console.warn('Store->set ABBORT "' + name + '" / Value has Changed  ', oldValue, '  ->  ', value, ' / Signal:' + signal + ' / Listeners: ' + handlers.length);

        }

        return true;
    }
    else {
        // Keine Änderung!
        if (Store._debug === true)
            console.log('Store->set X-NOTIFY "' + name + '" / Value has NOT Changed  ', oldValue, '  ==  ', value);
        return false;
    }
    //});
};
Store.prototype.has = function (name) {
    name = Store.validateName(name);
    if (name === false)
        return false;

    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        return false;
    }
    else {
        if (handlerObj.value === undefined || handlerObj.value === null)
            return false;
        else if (typeof handlerObj.value === 'string' && handlerObj.value.length == 0)
            return false;
        else if (typeof handlerObj.value === 'bool' || typeof handlerObj.value === 'boolean')
            return true;
        else if (typeof handlerObj.value === 'number' && isNaN(handlerObj.value)) // typeof value === 'number' && 
            return false;
        else
            return true;
    }

};
Store.prototype.get = function (name, defaultValue) {
    if (!this.has(name)) {
        if (Store._debug === true)
            console.log('Store->get - name not found', name, this);
        return defaultValue;
    }

    name = Store.validateName(name);
    if (name === false) {
        if (Store._debug === true)
            console.log('Store->get - name is null', name);
        return defaultValue;
    }

    let handlerObj = this._handlers[name];
    if (handlerObj.value === undefined || handlerObj.value === null) {
        if (Store._debug === true)
            console.warning('Store->get - empty value', name);
        return defaultValue;
    }
    else {
        return handlerObj.value;
    }
};
Store.prototype.update = function (name) {
    if (this.has(name)) {
        let value = this.get(name);
        //if (Store._debug === true)
        //console.log('Store->update: ', name, ' => ', value, typeof value);
        this.set(name, value, true);
    }
    else {
        if (Store._debug === true)
            console.warn('Store->update: Nothing to update..: ', name);
    }
};
/*
var store = new Store();
console.log('Store 1', store);
store.subscribe('selected-archive', (value, oldValue) => {
    console.log('Changed selected-archive  ', oldValue, ' => ', value);
});
console.log('Store 2', store);
store.set('selected-archive', 1);
console.log('Store 3', store);
console.log('Store 3 get: ', store.get('selected-archive'));
store.set('selected-archive', { sdsd: 'dsdsdsdsdsds'});
console.log('Store 4 get: ', store.get('selected-archive'));
store.unsubscribeAll('selected-archive');
console.log('Store 5', store);
store.remove('selected-archive');
console.log('Store 6', store);
*/

